import axios from "axios";
import { toast } from "react-toastify";
import { clearUser } from "./authSlice";

let navigateToLogin;
let dispatch;
let isRedirecting = false;

export const setNavigateFunction = (navigateFn, dispatchFn) => {
  navigateToLogin = navigateFn;
  dispatch = dispatchFn;
};

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

apiInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error?.response?.status === 410 && !isRedirecting) {
      isRedirecting = true;

      if (dispatch) dispatch(clearUser());
      if (navigateToLogin) navigateToLogin("/login");

      setTimeout(() => {
        isRedirecting = false;
      }, 1000);

    } else if (error?.response?.data?.message) {
      toast.error(error?.response?.data?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
    }

    return Promise.reject(error);
  }
);